import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";
import { TranslationService } from "../../_services/translation.service";
import { ActivatedRoute, ParamMap } from "@angular/router";
import { ChildModal } from "../../child";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { GenericChartModalContainerComponent } from "../../admin/charts/generic-chart-modal/generic-chart-modal-container.component";
import { DevToolsService } from "../../_services/dev-tools.service";
import { StoriesTypes } from "./stories-types";
import { contributionFixtures } from "../../../tests/fixtures/contribution.fixtures";

@Component({
  selector: "stories-component",
  templateUrl: "stories.component.html",
  styleUrls: ["../development.component.scss", "stories.component.scss"],
})
export class StoriesComponent implements OnInit, AfterViewInit {
  @ViewChild("childModalRef") public childModalRef: ChildModal;
  public translations$: Observable<ITranslations>;
  public contributionFixture = contributionFixtures.simpleContribution;
  public showAllLinks: boolean = false;
  public StoriesTypes = StoriesTypes;
  public id: string;
  public storyType: StoriesTypes = StoriesTypes.NoStory;
  public stubData = {
    child: {
      firstName: "אבי",
      lastName: "כהן",
    },
  };
  public allLinks: Array<{ path: string; name: string; key: StoriesTypes }> =
    this.updateAllLinks();
  public readonly buildLinkName = StoriesComponent.buildLinkName;

  constructor(
    private translationService: TranslationService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private devToolsService: DevToolsService
  ) {
    this.translations$ = this.translationService.translations;
  }
  public static convertStoriesToLinks(
    stories: StoriesTypes[]
  ): Array<{ path: string; name: string; key: StoriesTypes }> {
    return stories.map((value) => {
      const pathName = StoriesComponent.buildLinkName(value);
      return { path: value as string, name: pathName, key: value };
    });
  }
  public static buildLinkName = (link: StoriesTypes): string => {
    const storyType = link || ("" as string);
    return storyType
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  public ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.id = params.get("id");

      if (Object.values(StoriesTypes).includes(this.id)) {
        this.storyType = this.id as StoriesTypes;
      }
    });
  }
  public ngAfterViewInit(): void {
    switch (this.storyType) {
      case StoriesTypes.ChildPopup:
        document.getElementById("child-modal-opening-button").click();
        break;
      case StoriesTypes.UserPopup:
        this.stubData.child.firstName = "אבי";
        this.stubData.child.lastName = "כהן";
        break;
      case StoriesTypes.ChartModal:
        const modalRef: NgbModalRef = this.modalService.open(
          GenericChartModalContainerComponent,
          GenericChartModalContainerComponent.modalOptions
        );
        break;
      default:
        break;
    }
  }

  public storyClicked(link: { path: string; name: string; key: StoriesTypes }) {
    this.devToolsService.clickedStory(link.key);
  }

  public fakeClick($event: {
    price: number;
    index: number;
    fromModal: boolean;
  }) {}
  public updateAllLinks() {
    return StoriesComponent.convertStoriesToLinks(
      //@ts-expect-error this is ok
      Object.values(StoriesTypes)
        .filter(
          (value) =>
            typeof value === "string" &&
            value !== StoriesTypes[StoriesTypes.NoStory]
        )
        .filter((l, i) => this.showAllLinks || i < 5)
    );
  }
  public setShowAllLinks() {
    this.showAllLinks = !this.showAllLinks;
    this.allLinks = this.updateAllLinks();
  }
}



// WEBPACK FOOTER //
// ./src/app/development/stories/stories.component.ts